import script from "./RechargePanel.vue?vue&type=script&setup=true&lang=js"
export * from "./RechargePanel.vue?vue&type=script&setup=true&lang=js"

import "./RechargePanel.vue?vue&type=style&index=0&id=4bea4e37&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/duanju-overseas_admin_vue_live/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4bea4e37"]])

export default __exports__